var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ink_wrap"},[_c('span',{staticClass:"ink_text",style:({fontSize: _vm.percentComputed >= 100 ? '9px' : '12px'})},[_vm._v(_vm._s(_vm.percentComputed))]),_c('div',{staticClass:"ink_box",style:(_vm.styleObject)})])
}
var staticRenderFns = []

export { render, staticRenderFns }